import { component as defineComponent } from 'flightjs';

var slideShowTrigger = function() {
    this.attributes({
        broadcastEvent: '',
    });

    this.after('initialize', function() {
        this.on('click', this.broadcastAction);
    });

    this.broadcastAction = function() {
        var stepNumber = this.$node.attr('data-slideshow-trigger-step');

        this.trigger(this.attr.broadcastEvent, {
            step: stepNumber,
        });
    };
};

export default defineComponent(slideShowTrigger);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/slideshow-trigger.js